import { useEffect, useSyncExternalStore } from 'react'

let openPopovers = 0
const listeners = new Set<() => void>()

const notify = () => {
	for (const listener of listeners) {
		listener()
	}
}

/** True while any selection toolbar popover is open, for polls that would repaint behind it. */
export const isSelectionPopoverOpen = (): boolean => openPopovers > 0

const subscribe = (listener: () => void) => {
	listeners.add(listener)
	return () => {
		listeners.delete(listener)
	}
}

/** The same flag as a render value, for polls expressed as query options rather than timers. */
export const useIsSelectionPopoverOpen = (): boolean => useSyncExternalStore(subscribe, isSelectionPopoverOpen)

export function useSelectionPopoverHold(open: boolean): void {
	useEffect(() => {
		if (!open) {
			return
		}
		openPopovers += 1
		notify()
		return () => {
			openPopovers -= 1
			notify()
		}
	}, [open])
}
